import { Route, Routes } from 'react-router-dom';
import AccountBaseScreen from './screens/AccountBaseScreen';

Account.propTypes = {};

function Account(props) {
    return (
        <Routes>
            <Route path="*" element={<AccountBaseScreen />} />
        </Routes>
    );
}

export default Account;
